var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import clsx from 'clsx';
import { CircularProgress } from '@mui/material';
import ReactDOMServer from 'react-dom/server';
import Home from 'assets/icons/Home.png';
import HomeAway from 'assets/icons/HomeAway.png';
import Away from 'assets/icons/Away.png';
import CircleMarker from 'assets/icons/CircleMarker.png';
import BlueCircle from 'assets/icons/bluecirle.png';
import OrangeCircle from 'assets/icons/orangecircle.png';
import AwayTooltip from 'assets/icons/AwayTooltip.png';
import { LocationStatus } from 'globals/enums';
import { getAddressByLatLng, getTimestamp, loadGoogleMapsScript } from 'globals/global.functions';
import { mapComponentStyle } from './MapComponent.style';
import MarkerTooltipComponent from './MarkerTooltipComponent';
var MapComponent = function (_a) {
    var _b;
    var atHome = _a.atHome, isLoading = _a.isLoading, homeCoordinates = _a.homeCoordinates, currentCoordinates = _a.currentCoordinates, historyData = _a.historyData, _c = _a.iconScale, iconScale = _c === void 0 ? { x: 35, y: 50 } : _c, mapOptions = _a.mapOptions, className = _a.className, onClick = _a.onClick, timezone = _a.timezone, showTooltipOnMap = _a.showTooltipOnMap;
    var classes = mapComponentStyle().classes;
    var ref = useRef(null);
    var tooltipZIndex = 10;
    var LegendItem = function (_a) {
        var color = _a.color, label = _a.label;
        return (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 6 }, children: [_jsx("div", { style: {
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: color,
                    } }), _jsx("span", { style: { fontSize: 11, color: '#333' }, children: label })] }));
    };
    useEffect(function () {
        var initMap = function () { return __awaiter(void 0, void 0, void 0, function () {
            var apiKey, polylinePath_1, HomeIcon, HomeAwayIcon, AwayIcon, CircleMarkerIcon_1, OrangeCircleMarkerIcon_1, BlueCircleMarkerIcon_1, bounds_1, maps_1, currentLatLng, lineSymbol, polyline, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        apiKey = process.env.REACT_APP_CARE_PORTAL_GOOGLE_API_KEY || '';
                        polylinePath_1 = [];
                        return [4 /*yield*/, loadGoogleMapsScript(apiKey)];
                    case 1:
                        _a.sent();
                        HomeIcon = {
                            url: Home,
                            scaledSize: new google.maps.Size(iconScale.x, iconScale.y),
                        };
                        HomeAwayIcon = {
                            url: HomeAway,
                            scaledSize: new google.maps.Size(iconScale.x, iconScale.y),
                        };
                        AwayIcon = {
                            url: Away,
                            scaledSize: new google.maps.Size(iconScale.x, iconScale.y),
                        };
                        CircleMarkerIcon_1 = {
                            url: CircleMarker,
                            scaledSize: new google.maps.Size(30, 30),
                        };
                        OrangeCircleMarkerIcon_1 = {
                            url: OrangeCircle,
                            scaledSize: new google.maps.Size(30, 30),
                        };
                        BlueCircleMarkerIcon_1 = {
                            url: BlueCircle,
                            scaledSize: new google.maps.Size(30, 30),
                        };
                        if (ref.current && atHome !== LocationStatus.NO_LOCATION) {
                            bounds_1 = new google.maps.LatLngBounds();
                            maps_1 = new google.maps.Map(ref.current, mapOptions);
                            if (onClick) {
                                maps_1.addListener('click', function () { return onClick(); });
                            }
                            addMarkerOnMap({
                                map: maps_1,
                                boundaries: bounds_1,
                                lat: homeCoordinates.latitude,
                                lng: homeCoordinates.longitude,
                                locationSource: homeCoordinates.locationSource,
                                icon: atHome === LocationStatus.AWAY ? HomeAwayIcon : HomeIcon,
                                label: 'none',
                                showTooltipOnMarker: false,
                            });
                            polylinePath_1.push(new google.maps.LatLng(homeCoordinates.latitude, homeCoordinates.longitude));
                            historyData === null || historyData === void 0 ? void 0 : historyData.forEach(function (item, index) {
                                if (index < historyData.length) {
                                    var latLng = new google.maps.LatLng(item.latitude, item.longitude);
                                    polylinePath_1.push(latLng);
                                    var markerIcon = BlueCircleMarkerIcon_1;
                                    var tooltipIcon = BlueCircle;
                                    if (item.is_fall) {
                                        markerIcon = OrangeCircleMarkerIcon_1;
                                        tooltipIcon = OrangeCircle;
                                    }
                                    else if (item.is_sos) {
                                        markerIcon = CircleMarkerIcon_1;
                                        tooltipIcon = CircleMarker;
                                    }
                                    addMarkerOnMap({
                                        map: maps_1,
                                        boundaries: bounds_1,
                                        lat: item.latitude,
                                        lng: item.longitude,
                                        locationSource: item.locationSource,
                                        icon: markerIcon,
                                        label: index + 1,
                                        showTooltipOnMarker: true,
                                        tooltipIcon: tooltipIcon,
                                        timestamp: item.timestamp,
                                    });
                                }
                            });
                            if (atHome === LocationStatus.AWAY) {
                                currentLatLng = new google.maps.LatLng(currentCoordinates.latitude, currentCoordinates.longitude);
                                polylinePath_1.push(currentLatLng);
                                addMarkerOnMap({
                                    map: maps_1,
                                    boundaries: bounds_1,
                                    lat: currentCoordinates.latitude,
                                    lng: currentCoordinates.longitude,
                                    locationSource: currentCoordinates.locationSource,
                                    icon: AwayIcon,
                                    label: 'none',
                                    showTooltipOnMarker: true,
                                    tooltipIcon: AwayTooltip,
                                    timestamp: getTimestamp(currentCoordinates.timestamp),
                                });
                            }
                            if (atHome === LocationStatus.HOME && !historyData) {
                                maps_1.setZoom(15);
                                maps_1.setCenter(new google.maps.LatLng(homeCoordinates.latitude, homeCoordinates.longitude));
                            }
                            else if (currentCoordinates.latitude) {
                                maps_1.setZoom(15);
                                maps_1.setCenter(new google.maps.LatLng(currentCoordinates.latitude, currentCoordinates.longitude));
                            }
                            else {
                                setTimeout(function () { return maps_1.fitBounds(bounds_1); }, 500);
                            }
                            if (polylinePath_1.length > 1) {
                                lineSymbol = {
                                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                    scale: 3,
                                    strokeColor: '#000',
                                };
                                polyline = new google.maps.Polyline({
                                    path: polylinePath_1,
                                    geodesic: true,
                                    strokeColor: '#17e010ff',
                                    strokeOpacity: 0.8,
                                    strokeWeight: 4,
                                    icons: [
                                        {
                                            icon: lineSymbol,
                                            offset: '50%',
                                            repeat: '100px',
                                        },
                                    ],
                                });
                                polyline.setMap(maps_1);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to load Google Maps:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        initMap();
    }, [ref, atHome]);
    var addMarkerOnMap = function (_a) {
        var map = _a.map, boundaries = _a.boundaries, lat = _a.lat, lng = _a.lng, locationSource = _a.locationSource, icon = _a.icon, label = _a.label, showTooltipOnMarker = _a.showTooltipOnMarker, tooltipIcon = _a.tooltipIcon, timestamp = _a.timestamp;
        if (!lat || !lng)
            return;
        var isAway = currentCoordinates.latitude === lat &&
            currentCoordinates.longitude === lng;
        var markerLatLng = new google.maps.LatLng(lat, lng);
        var marker = new google.maps.Marker({
            position: markerLatLng,
            icon: icon,
            label: { text: "".concat(label === 'none' ? ' ' : label), color: 'white' },
        });
        if (showTooltipOnMap && showTooltipOnMarker) {
            getTooltipOnMarker(map, lat, lng, locationSource, label, marker, tooltipIcon, timestamp);
        }
        if (isAway) {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function () { return marker.setAnimation(null); }, 10000);
        }
        marker.setMap(map);
        if (onClick)
            marker.addListener('click', function () { return onClick(); });
        boundaries.extend(markerLatLng);
    };
    var getTooltipOnMarker = function (map, lat, lng, locationSource, label, marker, tooltipIcon, timestamp) { return __awaiter(void 0, void 0, void 0, function () {
        var contentString, infoWindow, openInfoWindow, handleMarkerClick, mouseover, mouseout, click;
        return __generator(this, function (_a) {
            contentString = ReactDOMServer.renderToString(_jsx(MarkerTooltipComponent, { latitude: lat, longitude: lng, addressPlaceholder: "Click to get address", address: "", timestamp: timestamp, tooltipIcon: tooltipIcon, label: label, timezone: timezone, locationSource: locationSource }));
            infoWindow = new google.maps.InfoWindow({
                content: contentString,
                disableAutoPan: true,
            });
            openInfoWindow = function () {
                infoWindow.open({ anchor: marker, map: map, shouldFocus: false });
            };
            handleMarkerClick = function () { return __awaiter(void 0, void 0, void 0, function () {
                var addr, updatedContent;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            infoWindow.setOptions({ disableAutoPan: false });
                            return [4 /*yield*/, getAddressByLatLng(lat, lng)];
                        case 1:
                            addr = _a.sent();
                            updatedContent = ReactDOMServer.renderToString(_jsx(MarkerTooltipComponent, { latitude: lat, longitude: lng, addressPlaceholder: "No address found", address: addr, timestamp: timestamp, tooltipIcon: tooltipIcon, label: label, timezone: timezone, locationSource: locationSource }));
                            infoWindow.setContent(updatedContent);
                            openInfoWindow();
                            return [2 /*return*/];
                    }
                });
            }); };
            mouseover = marker.addListener('mouseover', openInfoWindow);
            mouseout = marker.addListener('mouseout', function () { return infoWindow.close(); });
            click = marker.addListener('click', handleMarkerClick);
            google.maps.event.addListener(infoWindow, 'closeclick', function () {
                marker.addListener('mouseover', openInfoWindow);
            });
            return [2 /*return*/];
        });
    }); };
    if (isLoading) {
        return _jsx(CircularProgress, { "data-testid": "loader" });
    }
    return (_jsxs("div", { style: { position: 'relative', width: '100%', height: '100%' }, className: className, children: [_jsx("div", { "data-testid": "map-component", ref: ref, id: "map", className: clsx((_b = {},
                    _b[className] = true,
                    _b[classes.mapContainer] = true,
                    _b[classes.mapBackgroundColor] = LocationStatus.NO_LOCATION,
                    _b)) }), _jsxs("div", { style: {
                    position: 'absolute',
                    bottom: 8,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'rgba(255,255,255,0.95)',
                    padding: '4px 10px',
                    borderRadius: 6,
                    display: 'flex',
                    gap: 12,
                    alignItems: 'center',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    zIndex: 5,
                    pointerEvents: 'none',
                }, children: [_jsx(LegendItem, { color: "#1976d2", label: "Geolocation" }), _jsx(LegendItem, { color: "#d32f2f", label: "SOS" }), _jsx(LegendItem, { color: "#f57c00", label: "Fall" })] })] }));
};
export default MapComponent;
